import { Text, StyleSheet } from "react-native";
import SimplePress from "./SimplePress";

const CustomButton = ({ children, onPress, style, disabled }) => {
  const textstyle =
    style ? (Array.isArray(style) ? Object.assign({}, ...style) : style):undefined;

    return (
    <SimplePress
      onPress={onPress}
      style={[styles.sendButton, style, disabled && styles.disabledButton]}
      disabled={disabled}
    >
      <Text style={[styles.sendText, textstyle && { color: textstyle.color }]}>
        {children}
      </Text>
    </SimplePress>
  );
};

export default CustomButton;

const styles = StyleSheet.create({
  sendButton: {
    backgroundColor: "#407daf",
    padding: 20,
    borderRadius: 10,
    marginBottom: 30,
  },
  disabledButton: {
    backgroundColor: "#999999",
  },
  sendText: {
    textAlign: "center",
    fontWeight: "700",
    fontSize: 16,
    color: "#fff",
  },
});
